import {
  FEATURES_PAGE,
  KNOWLEDGEBASE_PAGE,
  ABOUT_PAGE,
  BLOG_PAGE,
} from '@/constants/pagesUrl.js';

const nav = [
  {
    text: 'Features',
    href: FEATURES_PAGE,
  },
  {
    text: 'Knowledgebase',
    href: KNOWLEDGEBASE_PAGE,
  },
  {
    text: 'About',
    href: ABOUT_PAGE,
  },
  {
    text: 'Blog',
    href: BLOG_PAGE,
  },
];

export default nav;
